import { loginWithEmailPassword, loginWithGoogle, registerEmailPassword, verifyEmail, type Role } from '../api/client'

export const authAdapter = {
  loginWithEmailPassword: (email: string, password: string) => loginWithEmailPassword({ email, password, remember: true }),
  loginWithGoogle: (idToken: string) => loginWithGoogle(idToken),
  register: (email: string, mobile: string, password: string, role: Role) => registerEmailPassword({ email, mobile, password, role }),
  verifyEmail: (token: string) => verifyEmail({ token })
}
